import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { fmtHour } from "@/lib/api";
import { format, parseISO } from "date-fns";

export const CancelBookingDialog = ({ booking, onClose, onConfirm }) => {
  const [notify, setNotify] = useState(true);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (booking) { setNotify(true); setReason(""); setBusy(false); } }, [booking]);
  const confirm = async () => { setBusy(true); await onConfirm({ status: "cancelled", notify, cancel_reason: reason.trim() }); setBusy(false); };
  return (
    <Dialog open={!!booking} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#0d0d0d] border-white/10 text-white max-w-md" data-testid="cancel-booking-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Cancel this booking?</DialogTitle>
          <DialogDescription className="text-white/50">
            {booking && `${booking.name} — ${booking.service_title}, ${booking.event_date ? format(parseISO(booking.event_date), "EEE, MMM d, yyyy") : ""} at ${fmtHour(booking.start_time)}`}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <label className="flex items-center justify-between gap-3 rounded-lg border border-white/10 px-3 py-2.5">
            <span className="text-sm text-white/80">Notify customer <span className="text-white/40 text-xs block">Email, plus a text if they opted in to SMS</span></span>
            <Switch checked={notify} onCheckedChange={setNotify} data-testid="cancel-notify-switch" />
          </label>
          <div>
            <label className="text-white/50 text-[10px] uppercase font-mono-label">Reason / note to customer (optional)</label>
            <Textarea rows={3} maxLength={300} value={reason} onChange={(e) => setReason(e.target.value)} disabled={!notify}
              placeholder="e.g. Studio maintenance — we'll call you to reschedule." className="mt-1 bg-[#0a0a0a] border-white/15 text-sm" data-testid="cancel-reason-input" />
          </div>
          <div className="flex gap-2 justify-end">
            <button onClick={onClose} className="rounded-full px-5 py-2 text-xs border border-white/15 text-white/70" data-testid="cancel-keep-btn">Keep booking</button>
            <button onClick={confirm} disabled={busy} className="rounded-full px-5 py-2 text-xs bg-red-500/80 hover:bg-red-500 text-white disabled:opacity-50" data-testid="cancel-confirm-btn">
              {busy ? "Cancelling…" : "Cancel booking"}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
